<template>
  <div id="app">
    <nav-bar ref="impactnavbar" />
    <hero />
    <main>
      <services ref="services" />
      <about ref="about" />
      <vendors ref="vendors" />
      <contact ref="contact" />
    </main>
    <footersection ref="footersection" />
  </div>
</template>

<script>
import NavBar from "@/components/elements/NavBar";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import About from "@/components/sections/About";
import Contact from "@/components/sections/Contact";
import Vendors from "@/components/sections/Vendors";
import Footersection from "@/components/sections/Footer";

export default {
  name: 'App',
  components: {
    Footersection,
    Vendors,
    Contact,
    Hero,
    Services,
    About,
    NavBar,
  },
  computed: {
    navheight: function () {
      return this.$refs.impactnavbar.$el.clientHeight;
    }
  },
  provide: function () {
    return {
      jumpTo: this.jumpTo,
      top: this.top
    }
  },
  methods: {
    top() {
      window.scrollTo(0, 0);
    },
    jumpTo(page) {
      let coordinate = this.$refs[page].$el.offsetTop - this.navheight;
      window.scrollTo(0, coordinate);
      coordinate = this.$refs[page].$el.offsetTop - this.navheight;
      window.scrollTo(0, coordinate);
    },
  }
}
</script>

<style lang="scss">
@import '@/styles/custom';
@import '../node_modules/bootstrap/scss/bootstrap.scss';

h4, .h4, h5, .h5, h6, .h6 {
  font-weight: 600;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //color: #2c3e50;
}

</style>
